import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import Vant from 'vant';
import 'vant/lib/index.css';
import '/static/css/common.css'
import animated from 'animate.css'
import '/svg.css'
import store from './store'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'





//路由守卫
router.beforeEach((to, from, next) => {
	if(to.meta.title){
		document.title=to.meta.title
	}
  if (to.matched.some(record => record.meta.requireAuth)) { // 判断该路由是否需要登录权限
    var GptMToken = window.localStorage.getItem("GptMToken");
	var loginFlag = window.localStorage.getItem("loginFlag");
    if(GptMToken && loginFlag){
			next();
		}else{			
			next('/GptIndex/GptIndex');
		}
  } else {
    next();
  }
});

const app = createApp(App)
// 全局注册el-icon
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}	







import uniappRequest from './api/axiosconf'
app.config.globalProperties.$applicationJson = uniappRequest.applicationJson
app.config.globalProperties.$multipartPost = uniappRequest.multipartPost
app.config.globalProperties.$post = uniappRequest.fetchPost
app.config.globalProperties.globalImgPath = uniappRequest.globalImgPath
app.use(animated)
app.use(store)
app.use(router)
app.use(Vant)
app.use(ElementPlus, {
  locale: zhCn,
})
app.mount('#app')